import React, { useState, useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';

export const TYPING_SPEED = 35; 

// 1. Adicionamos a nova prop 'isComplete'
export default function Typewriter({ text, onCharacterTyped, onTypingComplete, isComplete }) {
  const [displayedText, setDisplayedText] = useState('');
  const timeoutRef = useRef(null);

  useEffect(() => {
    // 2. Lógica principal de verificação
    // Se a mensagem já estiver marcada como completa, exibe o texto todo e encerra.
    if (isComplete) {
      setDisplayedText(text);
      return;
    }

    // Se não estiver completa, procede com a animação de digitação.
    if (text) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      
      let currentIndex = 0;
      setDisplayedText(''); 

      const typeNextChar = () => {
        const currentSubstring = text.substring(0, currentIndex + 1);
        setDisplayedText(currentSubstring);

        if (onCharacterTyped) {
          onCharacterTyped();
        }

        currentIndex++;

        if (currentIndex < text.length) {
          timeoutRef.current = setTimeout(typeNextChar, TYPING_SPEED);
        } else {
          if (onTypingComplete) {
            onTypingComplete();
          }
        }
      };

      timeoutRef.current = setTimeout(typeNextChar, TYPING_SPEED);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [text, onCharacterTyped, onTypingComplete, isComplete]); // 3. 'isComplete' adicionado às dependências

  return <ReactMarkdown>{displayedText}</ReactMarkdown>;
}